import { render, staticRenderFns } from "./allRole.vue?vue&type=template&id=8603382e&"
import script from "./allRole.vue?vue&type=script&lang=js&"
export * from "./allRole.vue?vue&type=script&lang=js&"
import style0 from "./allRole.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports